import React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { CrossCloseIcon } from "../../utils/icons/icons";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

interface DialogWrapperProps extends Omit<DialogProps, "onClose"> {
  children: React.ReactNode;
  onClose: () => void
  preventCloseOnOutsideClick?: boolean
  forceDialog?: boolean
}

const DialogWrapperWithClose: React.FC<DialogWrapperProps> = ({ children, onClose, preventCloseOnOutsideClick, forceDialog, title, ...props }) => {
  const matchesSmUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));

  const content = (
    <React.Fragment>
      {title != null && (
        <DialogTitle variant="h6" fontWeight="medium" sx={(theme) => ({ pb: `${0} !important`, pt: `${theme.spacing(3)} !important` })}>
          {title}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: "absolute",
              right: theme.spacing(1),
              top: theme.spacing(1),
              color: "secondary",
            })}
          >
            <CrossCloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      {children}
    </React.Fragment>
  );

  return matchesSmUp || forceDialog ? (
    <Dialog {...props} onClose={preventCloseOnOutsideClick ? undefined : onClose}>
      {content}
    </Dialog>
  ) : (
    <Drawer
      anchor="bottom"
      open={props.open}
      onClose={preventCloseOnOutsideClick ? undefined : onClose}
      PaperProps={{
        // Used for tests, and indicates overlaid content
        role: 'dialog',
        'aria-modal': true,
        sx: {
          borderTopLeftRadius: (theme) => theme.spacing(2),
          borderTopRightRadius: (theme) => theme.spacing(2),
          maxHeight: '90%',
        },
      }}
    >
      {content}
    </Drawer>
  );
};

export default DialogWrapperWithClose;
